module.exports = __webpack_public_path__ + "04_short_black.abaffe6d.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/dad/layer5/04_short_black.png
// module id = XKdi
// module chunks = 0